import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AdminGuard } from '../../guards/adminguard/admin-guard.guard';
import { AuthGuard } from '../../guards/authguard/auth-guard';
import { SharedModule } from '../../shared/shared.module';
import { SalespersonBudgetTableComponent } from './components/salesperson-budget-table/salesperson-budget-table.component';

const routes: Routes = [
  {
    path: '',
    component: SalespersonBudgetTableComponent,
    canActivate: [AuthGuard, AdminGuard]
  }
];

@NgModule({
  declarations: [SalespersonBudgetTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule.forChild({ extend: true }),
    RouterModule.forChild(routes)
  ]
})
export class SalespersonBudgetModule {}
